import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ReportTooltipTemplateContext } from '@core/reports-types';

import { ReportTooltipFooterComponent } from '../report-tooltip-footer/report-tooltip-footer.component';
import { ReportTooltipHeaderComponent } from '../report-tooltip-header/report-tooltip-header.component';
import { ReportTooltipItemsListComponent } from '../report-tooltip-items-list/report-tooltip-items-list.component';

@Component({
  selector: 'reports-tooltip-inner',
  styleUrls: ['./report-tooltip-inner.component.less'],
  template: ` @let contextVal = context();
    @if (contextVal.headerText) {
      <reports-tooltip-header
        [title]="contextVal.headerText"
        [color]="contextVal.headerIndicatorColor"
      />
    }

    <reports-tooltip-items-list
      [items]="contextVal.items"
      [activeId]="activeId()"
      [wrapValues]="contextVal.wrapValues ?? false"
    />

    @if (contextVal.footerPrimaryText || contextVal.footerSecondaryText) {
      <reports-tooltip-footer
        [primarySlotText]="contextVal.footerPrimaryText"
        [secondarySlotText]="contextVal.footerSecondaryText"
      />
    }`,
  imports: [
    ReportTooltipFooterComponent,
    ReportTooltipHeaderComponent,
    ReportTooltipItemsListComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportTooltipInnerComponent {
  public context = input.required<ReportTooltipTemplateContext>();
  public activeId = input<string>();
}
